import { TableRenderer } from "../widgets/table";
import institutionen from "./HCHS_Project_TEXTE.json";

export function AnsprechpartnerTable() {
  const headers = ["Institution", "Ansprechpartner"];
  const rows = institutionen.Institutionen.map((elem) => {
    const length_partners = elem.Ansprechpartner.length;
    return [elem.Name, <>{elem.Ansprechpartner.map((partner, index)=>{
      if (index+1 < length_partners) {
        partner = `${partner},`;
      }
      return <>{partner}<br /></>;
    })}</>];
    
  })

  return (
    <TableRenderer headers={headers} rows={rows}/>
  )
}
